var AudioVideoIndicatorsComponent = /** @class */ (function () {
    function AudioVideoIndicatorsComponent() {
    }
    return AudioVideoIndicatorsComponent;
}());
export { AudioVideoIndicatorsComponent };
